import Campus from "./Default/Campus";

export default Campus;
